"use strict";

import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';

import { delay } from '../../utils';

import SearchActions from '../../actions/SearchActions';
import SearchStore from '../../stores/SearchStore';

class Search extends React.Component {
  constructor() {
    super();

    this.state = {
      options: [],
      defaultSelected: [],
    };

    this._handleSelection = this._handleSelection.bind(this);
    this._handleTextChange = this._handleTextChange.bind(this);
    this._handleBlur = this._handleBlur.bind(this);
    this._handleSearchStore = this._handleSearchStore.bind(this);
    this._handleCustomChildren = this._handleCustomChildren.bind(this);
  };

  static propTypes = {
    onChange: React.PropTypes.func,
    onSelection: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.object
    ])
  };

  componentWillMount() {
    const { value } = this.props;

    if(value) {
      this.setState({ options: [value], defaultSelected: [value] });
    }

    SearchStore.listen(this._handleSearchStore);
  };

  componentWillUnmount() {
    SearchStore.unlisten(this._handleSearchStore);
  };

  render() {
    const { options, defaultSelected } = this.state;
    return(
      <Typeahead
        options={ options }
        labelKey={option => {
          if(typeof option === 'string') return option;
          if(typeof option === 'object' && option._source) return option._source.name;
          return option.name;
        }}
        filterBy={(option, text) => {
                  return true;
        }}
        defaultSelected={ defaultSelected }
        onInputChange={ this._handleTextChange }
        onChange={ this._handleSelection }
        placeholder="Search Organizations"
        renderMenuItemChildren={ this._handleCustomChildren }
        onBlur={ this._handleBlur }/>
    );
  };

  _handleSearchStore(state) {
    
    if(state._organizations) {
      this.setState({ options: state._organizations });
    }
  };

  _handleSelection(values) {
    if(values && values.length) {
      setTimeout(() => { this.props.onSelection(values[0]) }, 0);
    }
  };

  _handleTextChange(value) {
    if(typeof this.props.onChange === 'function') this.props.onChange(value);

    if(value && value !== '') {
      delay(() => {
        SearchActions.searchOrganizations({ keyword: value });
      }, 500);
    }
  };

  _handleBlur() {
    if(typeof this.props.onBlur === 'function') {
      setTimeout(() => { this.props.onBlur() }, 500);
    }
  }

  _handleCustomChildren(option) {
    return [
      <figure key="logo">
        <img 
          src={ option && option.logoUrl || option && option._source && option._source.logoUrl }
          style={{ maxWidth: 200, maxHeight: 200 }}
        />
      </figure>,
      <strong key="name">
        {
            typeof option === 'string' ? option :
            typeof option === 'object' && option._source ? option._source.name :
            option.name
        }
      </strong>
    ];
  }
}

export default Search;
